import { TextField, MenuItem } from '@mui/material'
import { CONTROLS } from '~/components/Charts/chrome/chartChrome'

interface Props {
  options: Array<{ value: string; label: string }>
  value: string
  onChange: (v: string) => void
  disabled?: boolean
}

export function ValueTypeSelector({ options, value, onChange, disabled }: Props) {
  return (
    <TextField
      select
      label={CONTROLS.valueType}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      sx={{ minWidth: 150 }}
    >
      {options.map((o) => (
        <MenuItem key={o.value} value={o.value}>
          {o.label}
        </MenuItem>
      ))}
    </TextField>
  )
}
